import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: { title: "首页" },
  },
  {
    path: "/quoteorder",
    name: "quoteorder",
    component: () => import("@/views/quoteorder/index.vue"),
    meta: { title: "报价下单" },
  },
  {
    path: "/aboutjuyi",
    name: "aboutjuyi",
    component: () => import("@/views/aboutjuyi/index.vue"),
    meta: { title: "关于宏泰" },
  },
  {
    path: "/productshow",
    name: "productshow",
    component: () => import("@/views/productshow/index.vue"),
    meta: { title: "产品展示" },
  },
  {
    path: "/videocourse",
    name: "videocourse",
    component: () => import("@/views/videocourse/index.vue"),
    meta: { title: "视频教程" },
  },
  {
    path: "/yinqianlook",
    name: "yinqianlook",
    component: () => import("@/views/yinqianlook/index.vue"),
    meta: { title: "印前必看" },
  },
  {
    path: "/contactus",
    name: "contactus",
    component: () => import("@/views/contactus/index.vue"),
    meta: { title: "联系我们" },
  },
  {
    path: "/couponcenter",
    name: "couponcenter",
    component: () => import("@/views/couponcenter/index.vue"),
    meta: { title: "领券中心" },
  },
  {
    path: "/mycoupon",
    name: "mycoupon",
    component: () => import("@/views/mycoupon/index.vue"),
    meta: { title: "我的优惠券" },
  },
  {
    path: "/orderpage",
    name: "orderpage",
    component: () => import("@/views/orderpage/index.vue"),
    meta: { title: "订单详情", istoken: true },
  },
  {
    path: "/orderpay",
    name: "orderpay",
    component: () => import("@/views/orderpay/index.vue"),
    meta: { title: "订单支付", istoken: true },
  },
  {
    path: "/usercenter",
    name: "usercenter",
    component: () => import("@/views/usercenter/index.vue"),
    meta: { title: "账号中心" },
    redirect: "/personcenter",
    children: [
      {
        path: "/personcenter",
        name: "personcenter",
        component: () =>
          import("@/views/usercenter/view/personcenter/index.vue"),
        meta: { title: "个人中心", istoken: true },

      },
      {
        path: "/qiyerenzheng",
        name: "qiyerenzheng",
        component: () =>
          import("@/views/usercenter/view/qiyerenzheng/index.vue"),
        meta: { title: "企业认证" },
      },
      {
        path: "/mineorder",
        name: "mineorder",
        component: () => import("@/views/usercenter/view/mineorder/index.vue"),
        meta: { title: "我的订单" },
      },
      {
        path: "/moneylog",
        name: "moneylog",
        component: () => import("@/views/usercenter/view/moneylog/index.vue"),
        meta: { title: "余额记录" },
      },
      {
        path: "/childmanage",
        name: "childmanage",
        component: () =>
          import("@/views/usercenter/view/childmanage/index.vue"),
        meta: { title: "子账号管理" },
      },
      {
        path: "/addressmanage",
        name: "addressmanage",
        component: () =>
          import("@/views/usercenter/view/addressmanage/index.vue"),
        meta: { title: "地址管理" },
      },
      {
        path: "/servicerecord",
        name: "servicerecord",
        component: () =>
          import("@/views/usercenter/view/servicerecord/index.vue"),
        meta: { title: "服务记录" },
      },
      {
        path: "/cart",
        name: "cart",
        component: () => import("@/views/usercenter/view/cart/index.vue"),
        meta: { title: "购物车" },
      },
      {
        path: "/userinfo",
        name: "userinfo",
        component: () => import("@/views/usercenter/view/userinfo/index.vue"),
        meta: { title: "账户信息" },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index.vue"),
    meta: { title: "注册" },
  },
  {
    path: "/forgotpad",
    name: "forgotpad",
    component: () => import("@/views/forgotpad/index.vue"),
    meta: { title: "忘记密码" },
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.meta.istoken) {
    const token = getToken();
    if (!token) {
      console.warn("未登录，跳转到登录页");
      setTimeout(() => {
        router.push('/login');
      }, 100);
      return
    }
  }
  if (from.name === to.name) {
    console.warn("阻止重复导航");
    return next(false);
  }
  next();
});

export default router;
